import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGradient20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconGradient20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 4.5h-5.803a.75.75 0 0 1-.174.788L2.5 13.31v1.19c0 .197.057.38.155.534l6.807-6.807a.75.75 0 0 1 1.061 1.06L4.311 15.5h1.878l3.273-3.273a.75.75 0 1 1 1.061 1.06L8.311 15.5H16.5a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1m-9.19 0h1.88L2.5 11.19V9.31zm-2.12 0H3.5a1 1 0 0 0-1 1v1.69zM1 8.993V5.5A2.5 2.5 0 0 1 3.5 3h13A2.5 2.5 0 0 1 19 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 14.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGradient20);
